var _excluded = ["classes", "className", "color", "InputProps", "label", "size", "variant"],
  _excluded2 = ["classes", "endAdornment", "startAdornment"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { cloneElement, forwardRef } from 'react';
import { inputBaseClasses } from '@mui/material/InputBase';
import { filledInputClasses } from '@mui/material/FilledInput';
import { inputAdornmentClasses } from '@mui/material/InputAdornment';
import { formHelperTextClasses } from '@mui/material/FormHelperText';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { formControlClasses } from '@mui/material/FormControl';
import { object, oneOf, string } from 'prop-types';
import clsx from 'clsx';
import TextField, { textFieldClasses } from '@mui/material/TextField';
import { alpha, styled } from '@mui/material/styles';
var transforms = {
  filled: {
    base: 'translate(12px, 20px) scale(1)',
    shrink: 'translate(12px, 10px) scale(0.75)'
  },
  outlined: {
    base: 'translate(14px, 20px) scale(1)',
    shrink: 'translate(14px, -6px) scale(0.75)'
  },
  standard: {
    base: 'translate(0, 24px) scale(1)',
    shrink: 'translate(0, 1.5px) scale(0.75)'
  }
};
var StyledTextField = styled(TextField)(function (_ref) {
  var _$concat$concat, _$concat2, _transforms$variant, _transforms$variant2, _$concat3, _$concat5, _ref2;
  var label = _ref.label,
    size = _ref.size,
    variant = _ref.variant,
    _ref$theme = _ref.theme,
    palette = _ref$theme.palette,
    borderRadius = _ref$theme.shape.borderRadius,
    spacing = _ref$theme.spacing,
    typography = _ref$theme.typography;
  var filledColor = palette.grey.A200;
  var filledOpacity = 0.09;
  var filledNoLabel = function filledNoLabel() {
    if (variant === 'filled' && !label) {
      return {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        paddingTop: 0,
        paddingBottom: 0
      };
    }
    return {};
  };
  var getFieldHeight = function getFieldHeight() {
    if (variant === 'standard') {
      return null;
    }
    if (size === 'small') {
      return spacing(8.5);
    }
    return spacing(9.5);
  };
  var getInputHeight = function getInputHeight() {
    // allow for 2px bottom border
    if (variant === 'standard') {
      return 'auto';
    }
    if (size === 'small') {
      return spacing(6);
    }
    return spacing(7);
  };
  return _ref2 = {}, _defineProperty(_ref2, "&.".concat(textFieldClasses.root), {
    minHeight: getFieldHeight()
  }), _defineProperty(_ref2, "& .".concat(inputBaseClasses.root), {
    minHeight: getInputHeight()
  }), _defineProperty(_ref2, "& .".concat(filledInputClasses.root), (_$concat2 = {
    backgroundColor: alpha(filledColor, filledOpacity),
    borderRadius: "".concat(borderRadius, "px ").concat(borderRadius, "px 0 0")
  }, _defineProperty(_$concat2, "&.".concat(filledInputClasses.underline, "::before"), {
    // bottom border color
    borderColor: alpha(palette.text.secondary, 0.5)
  }), _defineProperty(_$concat2, '&:hover', _defineProperty({
    backgroundColor: alpha(filledColor, filledOpacity + palette.action.hoverOpacity),
    borderColor: palette.text.primary
  }, "&.".concat(filledInputClasses.underline, "::before"), {
    // hover bottom border color
    borderColor: palette.text.primary,
    borderWidth: spacing(0.25)
  })), _defineProperty(_$concat2, "& .".concat(inputAdornmentClasses.root), {
    color: palette.action.active
  }), _defineProperty(_$concat2, "&.".concat(filledInputClasses.focused), {
    backgroundColor: alpha(filledColor, filledOpacity)
  }), _defineProperty(_$concat2, "&.".concat(filledInputClasses.error), _defineProperty({}, "&.".concat(filledInputClasses.underline, "::before"), {
    // error border color
    borderColor: palette.error.main,
    borderWidth: spacing(0.25)
  })), _defineProperty(_$concat2, "&.".concat(filledInputClasses.disabled, ", &.").concat(filledInputClasses.disabled, ":hover"), (_$concat$concat = {
    backgroundColor: alpha(palette.grey[400], 0.2)
  }, _defineProperty(_$concat$concat, "&.".concat(filledInputClasses.underline, "::before"), {
    // disabled border color
    borderColor: alpha(palette.text.disabled, 0.5),
    borderBottomStyle: 'solid',
    borderWidth: 1
  }), _defineProperty(_$concat$concat, "& .".concat(inputAdornmentClasses.root), {
    color: palette.action.disabled
  }), _$concat$concat)), _$concat2)), _defineProperty(_ref2, "& .".concat(formHelperTextClasses.root), _objectSpread(_objectSpread({}, typography.body2), {}, _defineProperty({
    color: palette.text.secondary,
    marginLeft: variant === 'standard' ? 0 : spacing(),
    marginTop: spacing(0.5)
  }, "&.".concat(formHelperTextClasses.error), {
    color: palette.error.main
  }))), _defineProperty(_ref2, "& .".concat(inputBaseClasses.input), _objectSpread(_objectSpread({}, filledNoLabel()), {}, {
    color: palette.text.primary,
    height: variant === 'standard' ? '1.48em' : undefined,
    '&:disabled': {
      color: palette.text.disabled
    }
  })), _defineProperty(_ref2, "& .".concat(inputLabelClasses.root), (_$concat3 = {}, _defineProperty(_$concat3, "&:not(.".concat(inputLabelClasses.focused, ")"), {
    color: palette.text.secondary
  }), _defineProperty(_$concat3, "lineHeight", 1), _defineProperty(_$concat3, "overflow", 'visible'), _defineProperty(_$concat3, "transform", (_transforms$variant = transforms[variant]) === null || _transforms$variant === void 0 ? void 0 : _transforms$variant.base), _defineProperty(_$concat3, "&.".concat(inputLabelClasses.shrink), {
    transform: (_transforms$variant2 = transforms[variant]) === null || _transforms$variant2 === void 0 ? void 0 : _transforms$variant2.shrink
  }), _defineProperty(_$concat3, "&.".concat(inputLabelClasses.disabled), {
    color: palette.text.disabled
  }), _defineProperty(_$concat3, "&.".concat(inputLabelClasses.error), {
    color: palette.error.main
  }), _$concat3)), _defineProperty(_ref2, "& .".concat(outlinedInputClasses.root), (_$concat5 = {
    borderRadius: borderRadius,
    '& fieldset': {
      borderColor: alpha(palette.grey[900], 0.3)
    },
    '&:hover': {
      '& fieldset': {
        borderColor: palette.text.primary
      }
    }
  }, _defineProperty(_$concat5, "&.".concat(outlinedInputClasses.disabled), _defineProperty({
    '&& fieldset, &&:hover fieldset': {
      borderColor: alpha(palette.text.disabled, 0.5)
    }
  }, "& .".concat(inputAdornmentClasses.root), {
    color: palette.action.disabled
  })), _defineProperty(_$concat5, "&.".concat(outlinedInputClasses.focused), {
    backgroundColor: 'none',
    '& fieldset, &:hover fieldset': {
      borderColor: palette.primary.main
    }
  }), _defineProperty(_$concat5, "& .".concat(outlinedInputClasses.error), {
    '& fieldset, &:hover fieldset': {
      borderColor: palette.error.main
    }
  }), _defineProperty(_$concat5, "& .".concat(inputAdornmentClasses.root), {
    color: palette.action.active
  }), _$concat5)), _defineProperty(_ref2, "&.".concat(formControlClasses.marginDense), _defineProperty({}, "& .".concat(inputLabelClasses.outlined, ":not(.").concat(inputLabelClasses.shrink, ")"), {
    transform: 'translate(14px, 22px) scale(1)'
  })), _ref2;
});
var SovosTextField = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var _FormHelperTextProps$;
  var classes = _ref3.classes,
    className = _ref3.className,
    _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'primary' : _ref3$color,
    _ref3$InputProps = _ref3.InputProps,
    InputProps = _ref3$InputProps === void 0 ? {} : _ref3$InputProps,
    label = _ref3.label,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'medium' : _ref3$size,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'filled' : _ref3$variant,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var inputPropsClasses = InputProps.classes,
    endAdornment = InputProps.endAdornment,
    startAdornment = InputProps.startAdornment,
    inputPropsRest = _objectWithoutProperties(InputProps, _excluded2);
  var cloneAdornment = function cloneAdornment(adornment) {
    var _adornment$props;
    if (!adornment) {
      return undefined;
    }

    // Autocomplete adds multiple end adornments when rendering chips in multi-select mode, handle an array by cloning
    // each element
    if (Array.isArray(adornment)) {
      return adornment.map(cloneAdornment);
    }
    return /*#__PURE__*/cloneElement(adornment, {
      classes: _objectSpread(_objectSpread({}, ((_adornment$props = adornment.props) === null || _adornment$props === void 0 ? void 0 : _adornment$props.classes) || {}), {}, {
        root: classes === null || classes === void 0 ? void 0 : classes.adornmentRoot
      })
    });
  };
  var isFilled = variant === 'filled';
  var inputProps = _objectSpread({
    classes: _objectSpread(_objectSpread({}, inputPropsClasses), {}, {
      root: clsx(isFilled ? classes === null || classes === void 0 ? void 0 : classes.filledInputRoot : classes === null || classes === void 0 ? void 0 : classes.outlinedInputRoot, inputPropsClasses === null || inputPropsClasses === void 0 ? void 0 : inputPropsClasses.root),
      disabled: classes === null || classes === void 0 ? void 0 : classes.disabled,
      error: clsx(classes === null || classes === void 0 ? void 0 : classes.error, inputPropsClasses === null || inputPropsClasses === void 0 ? void 0 : inputPropsClasses.error),
      focused: classes === null || classes === void 0 ? void 0 : classes.focused,
      input: classes === null || classes === void 0 ? void 0 : classes.input,
      underline: isFilled ? classes === null || classes === void 0 ? void 0 : classes.underline : undefined
    }),
    endAdornment: cloneAdornment(endAdornment),
    startAdornment: cloneAdornment(startAdornment)
  }, inputPropsRest);
  var FormHelperTextProps = rest.FormHelperTextProps;
  return /*#__PURE__*/React.createElement(StyledTextField, _extends({
    autoComplete: "off",
    className: clsx('sovosTextField', className, classes === null || classes === void 0 ? void 0 : classes.root),
    color: color,
    FormHelperTextProps: _objectSpread(_objectSpread({}, FormHelperTextProps || {}), {}, {
      classes: {
        root: clsx(classes === null || classes === void 0 ? void 0 : classes.helperRoot, FormHelperTextProps === null || FormHelperTextProps === void 0 || (_FormHelperTextProps$ = FormHelperTextProps.classes) === null || _FormHelperTextProps$ === void 0 ? void 0 : _FormHelperTextProps$.root)
      }
    }),
    InputProps: inputProps,
    InputLabelProps: {
      classes: {
        root: classes === null || classes === void 0 ? void 0 : classes.label,
        disabled: classes === null || classes === void 0 ? void 0 : classes.labelDisabled,
        marginDense: classes === null || classes === void 0 ? void 0 : classes.marginDense,
        outlined: classes === null || classes === void 0 ? void 0 : classes.outLinedLabel,
        shrink: classes === null || classes === void 0 ? void 0 : classes.shrink
      }
    },
    label: label,
    ref: ref,
    size: size,
    variant: variant
  }, rest));
});
SovosTextField.propTypes = {
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * One of the Material UI theme colors
   */
  color: oneOf(['primary']),
  /**
   * Properties for the underlying Material UI Input component
   */
  InputProps: object,
  /**
   * Label of the input
   */
  label: string,
  /**
   * Size of the TextField
   */
  size: oneOf(['medium', 'small']),
  /**
   * Text field variant
   */
  variant: oneOf(['filled', 'outlined', 'standard'])
};
SovosTextField.baseComponent = {
  name: 'Text Field',
  link: 'text-field/'
};
export default SovosTextField;